export const pcRouter = [
  // pc端中文版路由
  //#region
  {
    path: "/",
    name: "chHome",
    component: () => import('@/views/pc/index/index'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/projection",
    name: "chProjection",
    component: () => import('@/views/pc/projection/projection'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/SoftwareSubscriptions",
    name: "chSoftwareSubscriptions",
    component: () => import('@/views/pc/SoftwareSubscriptions/SoftwareSubscriptions'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/CaseDemonstration",
    name: "chCaseDemonstration",
    component: () => import('@/views/pc/CaseDemonstration/CaseDemonstration'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/casepresentation",
    name: "chcase_presentation",
    component: () => import('@/views/pc/CasePresentation/case_presentation'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/projectorbit",
    name: "chprojectorbit",
    component: () => import('@/views/pc/projectorbit/projectorbit'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/lightingDesign",
    name: "chlightingDesign",
    component: () => import('@/views/pc/lighting_design/lighting_design'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/virtualProduction",
    name: "chvirtualProduction",
    component: () => import('@/views/pc/virtual_production/virtual_production'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/renderInteraction",
    name: "chrenderInteraction",
    component: () => import('@/views/pc/render_interaction/render_interaction'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/hecoosLighting",
    name: "chhecoosLighting",
    component: () => import('@/views/pc/hecoos_lighting/hecoos_lighting'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/mediaServer",
    name: "chmediaServer",
    component: () => import('@/views/pc/media_server/media_server'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/studio",
    name: "chstudio",
    component: () => import('@/views/pc/studio/studio'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/construction",
    name: "chconstruction",
    component: () => import('@/views/pc/construction/construction.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/understand",
    name: "Understand",
    component: () => import('@/views/pc/understand/understand.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/offlineversion",
    name: "chofflineversion",
    component: () => import('@/views/pc/offlineversion/offlineversion.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/login",
    name: "chLogin",
    component: () => import('@/views/pc/login/login.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/Register",
    name: "chRegister",
    component: () => import('@/views/pc/register/register.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/order",
    name: "chOrder",
    component: () => import('@/views/pc/order/order.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import('@/views/pc/personal_center/personal_center.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/video_tutorial",
    name: "videoTutorial",
    component: () => import('@/views/pc/video_tutorial/video_tutorial.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/forget_password",
    name: "forgetPassword",
    component: () => import('@/views/pc/forget_password/forget_password.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component: () => import('@/views/pc/paySuccess/paySuccess.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import('@/views/pc/policy_agreement/privacy_policy.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/llm-info",
    name: "llmInfo",
    component: () => import('@/views/pc/LlmInfo/index.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/serviceAgreement",
    name: "serviceAgreement",
    component: () => import('@/views/pc/policy_agreement/service_agreement.vue'),
    meta: {
      language: 'ch'
    }
  },

  //#endregion

  // pc端英文版路由
  //#region
  {
    path: "/en/",
    name: "enHome",
    component: () => import('@/views/en_pc/index/index'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/projection",
    name: "enProjection",
    component: () => import('@/views/en_pc/projection/projection'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/SoftwareSubscriptions",
    name: "enSoftwareSubscriptions",
    component: () => import('@/views/en_pc/SoftwareSubscriptions/SoftwareSubscriptions'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/CaseDemonstration",
    name: "enCaseDemonstration",
    component: () => import('@/views/en_pc/CaseDemonstration/CaseDemonstration'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/casepresentation",
    name: "encase_presentation",
    component: () => import('@/views/en_pc/CasePresentation/case_presentation'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/projectorbit",
    name: "enprojectorbit",
    component: () => import('@/views/en_pc/projectorbit/projectorbit'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/lightingDesign",
    name: "enlightingDesign",
    component: () => import('@/views/en_pc/lighting_design/lighting_design'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/virtualProduction",
    name: "envirtualProduction",
    component: () => import('@/views/en_pc/virtual_production/virtual_production'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/renderInteraction",
    name: "enrenderInteraction",
    component: () => import('@/views/en_pc/render_interaction/render_interaction'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/hecoosLighting",
    name: "enhecoosLighting",
    component: () => import('@/views/en_pc/hecoos_lighting/hecoos_lighting'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/mediaServer",
    name: "enmediaServer",
    component: () => import('@/views/en_pc/media_server/media_server'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/studio",
    name: "enstudio",
    component: () => import('@/views/en_pc/studio/studio'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/construction",
    name: "enconstruction",
    component: () => import('@/views/en_pc/construction/construction.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/Understand",
    name: "enUnderstand",
    component: () => import('@/views/en_pc/understand/understand.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/offlineversion",
    name: "enofflineversion",
    component: () => import('@/views/en_pc/offlineversion/offlineversion.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/login",
    name: "enLogin",
    component: () => import('@/views/en_pc/login/login.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/register",
    name: "enRegister",
    component: () => import('@/views/en_pc/register/register.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/personalCenter",
    name: "enPersonalCenter",
    component: () => import('@/views/en_pc/personal_center/personal_center.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/forget_password",
    name: "forgetPassword",
    component: () => import('@/views/en_pc/forget_password/forget_password.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/video_tutorial",
    name: "enVideoTutorial",
    component: () => import('@/views/en_pc/video_tutorial/video_tutorial.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/paySuccess",
    name: "enPaySuccess",
    component: () => import('@/views/en_pc/paySuccess/paySuccess.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/privacyPolicy",
    name: "privacyPolicy",
    component: () => import('@/views/en_pc/policy_agreement/privacy_policy.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/llm-info",
    name: "llmInfo",
    component: () => import('@/views/en_pc/LlmInfo/index.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/serviceAgreement",
    name: "serviceAgreement",
    component: () => import('@/views/en_pc/policy_agreement/service_agreement.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/order",
    name: "enOrder",
    component: () => import('@/views/en_pc/order/order.vue'),
    meta: {
      language: 'en'
    }
  },
  //#endregion
];
